export const megaUseCases = {
  securityprivacy: 'securityprivacy',
  databackup: 'databackup',
  streamingentertainment: 'streamingentertainment',
  parentalcontrol: 'parentalcontrol',
  productsetup: 'productsetup',
  passwordmanagement: 'passwordmanagement',
  productguidance: 'productguidance',
  wifievaluation: 'wifievaluation',
  customappointment: 'customappointment',
};

export const vhtSegments = {};

vhtSegments['SmartHomeSupport'] = {
  streamingentertainment: 'Verizon.en-us.Soluto_SHS_MUC1.',
  databackup: 'Verizon.en-us.Soluto_SHS_MUC2.',
  securityprivacy: 'Verizon.en-us.Soluto_SHS_MUC3.',
  parentalcontrol: 'Verizon.en-us.Soluto_SHS_MUC4.',
  wifievaluation: 'Verizon.en-us.Soluto_SHS_MUC5.',
  productguidance: 'Verizon.en-us.Soluto_SHS_MUC6.',
  passwordmanagement: 'Verizon.en-us.Soluto_SHS_MUC7.',
  productsetup: 'Verizon.en-us.Soluto_SHS_MUC8.',
  customappointment: 'Verizon.en-us.Soluto_SHS_MUC9.',
};

vhtSegments['VerizonProtectHome'] = {
  streamingentertainment: 'Verizon.en-us.Soluto_VPH_MUC1.',
  databackup: 'Verizon.en-us.Soluto_VPH_MUC2.',
  securityprivacy: 'Verizon.en-us.Soluto_VPH_MUC3.',
  parentalcontrol: 'Verizon.en-us.Soluto_VPH_MUC4.',
  wifievaluation: 'Verizon.en-us.Soluto_VPH_MUC5.',
  productguidance: 'Verizon.en-us.Soluto_VPH_MUC6.',
  passwordmanagement: 'Verizon.en-us.Soluto_VPH_MUC7.',
  productsetup: 'Verizon.en-us.Soluto_VPH_MUC8.',
  customappointment: 'Verizon.en-us.Soluto_VPH_MUC9.',
};

vhtSegments['VerizonProtectHomeFios'] = {
  streamingentertainment: 'Verizon.en-us.Soluto_FIOS_MUC1.',
  databackup: 'Verizon.en-us.Soluto_FIOS_MUC2.',
  securityprivacy: 'Verizon.en-us.Soluto_FIOS_MUC3.',
  parentalcontrol: 'Verizon.en-us.Soluto_FIOS_MUC4.',
  wifievaluation: 'Verizon.en-us.Soluto_FIOS_MUC5.',
  productguidance: 'Verizon.en-us.Soluto_FIOS_MUC6.',
  passwordmanagement: 'Verizon.en-us.Soluto_FIOS_MUC7.',
  productsetup: 'Verizon.en-us.Soluto_FIOS_MUC8.',
  customappointment: 'Verizon.en-us.Soluto_FIOS_MUC9.',
};

vhtSegments['CompleteMyHome'] = {
  streamingentertainment: 'Sprint.en-us.Soluto_MUC1.',
  databackup: 'Sprint.en-us.Soluto_MUC2.',
  securityprivacy: 'Sprint.en-us.Soluto_MUC3.',
  parentalcontrol: 'Sprint.en-us.Soluto_MUC4.',
  wifievaluation: 'Sprint.en-us.Soluto_MUC5.',
  productguidance: 'Sprint.en-us.Soluto_MUC6.',
  passwordmanagement: 'Sprint.en-us.Soluto_MUC7.',
  productsetup: 'Sprint.en-us.Soluto_MUC8.',
  customappointment: 'Sprint.en-us.Soluto_MUC9.',
};

vhtSegments['HomePlus'] = {
  streamingentertainment: 'AHomePlus.en-us.Soluto_MUC1.',
  databackup: 'AHomePlus.en-us.Soluto_MUC2.',
  securityprivacy: 'AHomePlus.en-us.Soluto_MUC3.',
  parentalcontrol: 'AHomePlus.en-us.Soluto_MUC4.',
  wifievaluation: 'AHomePlus.en-us.Soluto_MUC5.',
  productguidance: 'AHomePlus.en-us.Soluto_MUC6.',
  passwordmanagement: 'AHomePlus.en-us.Soluto_MUC7.',
  productsetup: 'AHomePlus.en-us.Soluto_MUC8.',
  customappointment: 'AHomePlus.en-us.Soluto_MUC9.',
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/config/megaUseCases.js